module.exports = __webpack_public_path__ + "static/media/purplerose1.38b0ad98.jpg";